import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'otto-olsen-email-signing-modal',
    templateUrl: './otto-olsen-email-signing-modal.component.html',
    styleUrl: './otto-olsen-email-signing-modal.component.scss',
    standalone: false
})
export class OttoOlsenEmailSigningModalComponent implements OnInit {
  email = '';
  componentId: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.componentId = OttoOlsenEmailSigningModalComponent.name;
  }

  confirm() {
    this.activeModal.close({ email: this.email });
  }

  cancel() {
    this.activeModal.dismiss();
  }

}
